var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0002 36.6673C29.2049 36.6673 36.6668 29.2054 36.6668 20.0007C36.6668 10.7959 29.2049 3.33398 20.0002 3.33398C10.7954 3.33398 3.3335 10.7959 3.3335 20.0007C3.3335 29.2054 10.7954 36.6673 20.0002 36.6673Z",
    fill: "#1D2435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1665 20.0005V17.5338C15.1665 14.3505 17.4165 13.0671 20.1665 14.6505L22.2998 15.8838L24.4332 17.1171C27.1832 18.7005 27.1832 21.3005 24.4332 22.8838L22.2998 24.1171L20.1665 25.3505C17.4165 26.9338 15.1665 25.6338 15.1665 22.4671V20.0005Z",
    fill: "#1D2435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3542870cc3fa71b95a10b805fb6e8687.svg";
export { ForwardRef as ReactComponent };